import {ACTION} from './constants';

let initialState={
    iappageDataLanding:{
        apiLoaded: false
    },
    iapCallUs:{
        apiLoaded: false
    },
    courses: [],
    childEducation: {},
    iapFAQsData: {
        apiLoaded: false,
    }
}

export default function IapLandingReducer(state=initialState, action) {
    switch (action.type) {
        case ACTION.IAP_DATA:
            return {...state, iappageDataLanding:{...action.data, apiLoaded: true}};
            case ACTION.IAP_CALL_US:
                return {...state, iapCallUs:{...action.data, apiLoaded: true}};
            case ACTION.GET_EDU_COURSES_CONTENT:
                return { ...state, courses: [...action.data], };
            case ACTION.IAP_FAQS:
                return { ...state, iapFAQsData:{...action.data, apiLoaded: true }};
            default:
            return state;
    }
}